module.exports = __webpack_public_path__ + "img/B_ezplan1.a67243f3.png";